<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <el-form style="width: 500px; display: flex;flex-direction: column;padding: 0 10px;">
              <el-form-item label="动画"    style="display: flex;">
                <el-input  style="width: 180px;"  v-model="type_animation" autocomplete="off"  placeholder="请填写(必填项)"  @input="validateInput"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/  &nbsp;秒
              </el-form-item>
              <el-form-item label="VR"   style="display: flex;">
                  <el-input   style="width: 180px;margin-left: 10px;"  v-model="type_vr" autocomplete="off"   placeholder="请填写"  @input="validateInput"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/  &nbsp;张
                </el-form-item>
                <el-form-item label="室内"   style="display: flex;">
                    <el-input style="width: 180px;"   v-model="type_indoor" autocomplete="off"   placeholder="请填写"   @input="validateInput"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/  &nbsp;张
                  </el-form-item>
                  <el-form-item label="鸟瞰"   style="display: flex;">
                      <el-input style="width: 180px;"   v-model="type_birdview" autocomplete="off"   placeholder="请填写"   @input="validateInput"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/  &nbsp;张
                    </el-form-item>
                    <el-form-item label="透视"   style="display: flex;">
                      <el-input style="width: 180px;"   v-model="type_perspective" autocomplete="off"   placeholder="请填写"   @input="validateInput"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/  &nbsp;张
                    </el-form-item>
                     <el-form-item label="规划"   style="display: flex;">
                        <el-input style="width: 180px;"   v-model="type_plan" autocomplete="off"   placeholder="请填写"  @input="validateInput"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/  &nbsp;张
                      </el-form-item>
                <span   :style="{
                  background: asd == true ? '#3383EA' : '#979797'
                }"  style="font-size: 14px;cursor: pointer;width: 80px;border-radius:5px;padding: 5px 0;color: #fff;" @click="saveEvt">保存</span>
        </el-form>
        </div>

      </div>
    </el-main>


  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'

import { ERPPriceApi   , ERPSaveprice } from "@/api/user_account/index.js"


export default {
  components: {
    GlobalHeader
  },
  data() {

    return {
      activeIndex: "12-2",
      type_birdview :null,
      type_perspective :null,
      type_indoor :null,
      type_vr   :null,
      type_animation :null,
      type_plan  :null,
      asd:false,
    };
  },
  created() {
         ERPPriceApi().then((res) => {
                this.type_birdview =res.data.type_birdview
                this.type_perspective =res.data.type_perspective
                this.type_indoor =res.data.type_indoor
                this.type_vr   =res.data.type_vr
                this.type_animation =res.data.type_animation
                this.type_plan  =res.data.type_plan
            })
  },
  mounted() {
  },

  methods: {
        saveEvt() {
          if (!this.type_birdview || !this.type_perspective || !this.type_indoor || !this.type_vr || !this.type_animation || !this.type_plan) {
            alert("不能为空");
            return;
          }

          this.$confirm('请确认是否保存?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
         ERPSaveprice({
          type_birdview: this.type_birdview,
          type_perspective: this.type_perspective,
          type_indoor: this.type_indoor,
          type_vr: this.type_vr,
          type_animation: this.type_animation,
          type_plan: this.type_plan,
        }).then(res => {
          // 处理保存成功后的逻辑
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

        },


      validateInput() {
        this.asd = true;
        // 使用正则表达式匹配整数和浮点数
        const regex = /^\d*$/;
        if (!regex.test(this.type_plan)) {
          // 如果输入不符合要求，则清空输入框
          this.type_plan = '';
        }
        if (!regex.test(this.type_perspective)) {
          // 如果输入不符合要求，则清空输入框
          this.type_perspective = '';
        }
        if (!regex.test(this.type_birdview)) {
        // 如果输入不符合要求，则清空输入框
          this.type_birdview = '';
        }
        if (!regex.test(this.type_indoor)) {
          // 如果输入不符合要求，则清空输入框
          this.type_indoor = '';
        }
        if (!regex.test(this.type_animation)) {
          // 如果输入不符合要求，则清空输入框
          this.type_animation = '';
        }
        if (!regex.test(this.type_vr)) {
          // 如果输入不符合要求，则清空输入框
          this.type_vr = '';
        }
      },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>

.el-main {
  left:175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}


</style>



// WEBPACK FOOTER //
// src/src/User_account/theoretical_price/index.vue